var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#34C2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.65 90.1557C47.65 114.298 66.9955 133.947 90.7871 133.947C93.9118 133.947 97.0166 133.605 100.009 132.934C100.662 132.819 101.149 132.245 101.149 131.559C101.149 130.687 100.318 130.005 99.4688 130.2C96.6541 130.836 93.7349 131.16 90.7871 131.16C68.5242 131.16 50.4047 112.772 50.4047 90.1557C50.4047 67.5396 68.5242 49.151 90.7871 49.151C113.05 49.151 131.17 67.5396 131.17 90.1557V90.2661C131.17 91.0312 131.781 91.6592 132.547 91.6592C133.313 91.6592 133.924 91.0312 133.924 90.2661V90.1557C133.924 66.0136 114.579 46.3648 90.7871 46.3648C66.9955 46.3648 47.65 66.0136 47.65 90.1557Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4098 61.882C89.4098 62.647 90.0208 63.2751 90.7871 63.2751C91.5535 63.2751 92.1645 62.647 92.1645 61.882V55.4845C92.1645 54.7194 91.5535 54.0914 90.7871 54.0914C90.0208 54.0914 89.4098 54.7194 89.4098 55.4845V61.882Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4098 124.826C89.4098 125.591 90.0208 126.219 90.7871 126.219C91.5535 126.219 92.1645 125.591 92.1645 124.826V118.429C92.1645 117.664 91.5535 117.036 90.7871 117.036C90.0208 117.036 89.4098 117.664 89.4098 118.429V124.826Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6382 91.5494H62.9394C63.7058 91.5494 64.3168 90.9214 64.3168 90.1564C64.3168 89.3913 63.7058 88.7633 62.9394 88.7633H56.6382C55.8719 88.7633 55.2608 89.3913 55.2608 90.1564C55.2608 90.9214 55.8719 91.5494 56.6382 91.5494Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7561 92.9077L94.7568 92.9091C94.9989 93.3953 95.4849 93.6757 95.9886 93.6757C96.1979 93.6757 96.4079 93.6254 96.6029 93.5291L96.603 93.5291L96.6073 93.5269L111.352 85.9886C111.352 85.9885 111.353 85.9884 111.353 85.9883C112.036 85.6413 112.299 84.8053 111.963 84.123C111.623 83.4332 110.795 83.1571 110.113 83.5033L110.112 83.5037L95.3669 91.042C95.3667 91.0421 95.3666 91.0422 95.3664 91.0423C94.6835 91.3893 94.42 92.2253 94.7561 92.9077Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7108 68.1333L79.7108 68.1333L79.7087 68.1343C79.0191 68.457 78.7148 69.2797 79.0258 69.9765C79.0258 69.9765 79.0258 69.9765 79.0258 69.9765L88.1908 90.5131C88.191 90.5134 88.1911 90.5137 88.1912 90.514C88.418 91.0282 88.9201 91.3357 89.4459 91.3357H89.4499C89.6445 91.3357 89.8381 91.2907 90.016 91.211L90.016 91.2111L90.0213 91.2086C90.7109 90.8859 91.0152 90.0632 90.7042 89.3664L81.5384 68.8281L81.5384 68.8281L81.5375 68.8261C81.2219 68.1308 80.4076 67.8127 79.7108 68.1333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1188 94.5732C85.1188 98.1443 87.9819 101.059 91.5121 101.059C95.0423 101.059 97.9055 98.1443 97.9055 94.5732C97.9055 91.0021 95.0423 88.0875 91.5121 88.0875C87.9819 88.0875 85.1188 91.0021 85.1188 94.5732ZM87.8735 94.5732C87.8735 92.5281 89.5106 90.8736 91.5121 90.8736C93.5136 90.8736 95.1508 92.5281 95.1508 94.5732C95.1508 96.6183 93.5136 98.2728 91.5121 98.2728C89.5106 98.2728 87.8735 96.6183 87.8735 94.5732Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6598 114.478C99.6598 126.14 109.005 135.636 120.505 135.636C132.004 135.636 141.35 126.14 141.35 114.478C141.35 102.816 132.004 93.3199 120.505 93.3199C109.005 93.3199 99.6598 102.816 99.6598 114.478ZM102.415 114.474C102.415 104.338 110.534 96.102 120.505 96.102C130.476 96.102 138.595 104.338 138.595 114.474C138.595 124.61 130.476 132.846 120.505 132.846C110.534 132.846 102.415 124.61 102.415 114.474Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.834 117.861L113.599 113.562C113.059 113.013 112.186 113.013 111.646 113.562C111.109 114.107 111.109 114.984 111.646 115.529L116.855 120.818C117.084 121.051 117.374 121.186 117.674 121.221L117.687 121.234H117.834C118.187 121.234 118.54 121.095 118.808 120.822L129.368 110.101C129.905 109.556 129.905 108.679 129.368 108.133L129.119 108.379L129.368 108.133C128.828 107.585 127.955 107.585 127.415 108.133L117.834 117.861Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.ea45d190ed6976555bf3ab34a8f12191.svg";
export { ForwardRef as ReactComponent };